import assert from '../assert';

/**
 * Performs left-to-right function composition.
 * The leftmost function may have any arity; the remaining functions must be unary.
 */
const pipe = (fn, ...fns) => {
  assert(typeof fn === 'function', 'Must provide at least one function');
  if (fns.length > 0) {
    const sequence = fns.reduce((f, g) => x => g(f(x)));
    return (...args) => sequence(fn(...args));
  }
  return (...args) => fn(...args);
};
export default pipe;